<ion-app>
  <ion-menu
    side="start"
    class="bepatient-left-menu"
    menuId="leftMenu"
    contentId="main-content"
    [swipeGesture]="false"
  >
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button (click)="menu.close('leftMenu')">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="bp-padding-double">
      <h3>
        {{ 'HELLO' | translate }},<br />
        {{ (user$ | async)?.personal.nickname }}
      </h3>
      <ion-list>
        <ion-menu-toggle auto-hide="false">
          <ion-item
            *ngFor="let module of entryPageModules$ | async"
            (click)="navigateToModule(module)"
          >
            <ion-icon slot="start" [name]="module.icon"></ion-icon>
            <ion-label>
              {{ module.i18nLabel | translate }}
            </ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <ion-button (click)="logout()">
              <ion-icon slot="start" name="log-out"></ion-icon>
              {{ 'LOGOUT' | translate }}
            </ion-button>
          </ion-menu-toggle>
        </ion-buttons>
        <span class="app-version" slot="end">
          {{ appVersion$ | async }}
        </span>
      </ion-toolbar>
    </ion-footer>
  </ion-menu>

  <ion-menu
    side="end"
    class="bepatient-right-menu"
    menuId="rightMenu"
    contentId="main-content"
    [swipeGesture]="false"
  >
    <ion-header>
      <router-outlet name="rightMenuHeader"></router-outlet>
    </ion-header>
    <ion-content>
      <router-outlet name="rightMenuContent"></router-outlet>
    </ion-content>
    <ion-footer>
      <router-outlet name="rightMenuFooter"></router-outlet>
    </ion-footer>
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
